import routes from './routes';
import api from './api';

const config = { routes, api };

export default config;
